import { addAccentBar, addCardChrome } from './chrome';
import { drawPipelineGlyph, getPipelineSymbolMeta, resolvePipelineSymbolKind, PIPELINE_SYMBOL_SIZE, } from './pipelineIcons';
import { getActiveDiagram } from './theme';
var SYMBOL_SIZE = PIPELINE_SYMBOL_SIZE;
var ACCENT_H = 4;
function categoryAccent(category) {
    var d = getActiveDiagram();
    switch (category) {
        case 'flow':
            return d.schematicSwitch;
        case 'gateway':
            return '#a78bfa';
        case 'event':
            return '#22d3ee';
        case 'io':
            return '#94a3b8';
        case 'queue':
            return '#38bdf8';
        case 'data':
            return d.schematicResistor;
        case 'notify':
            return '#fbbf24';
        case 'integration':
            return '#60a5fa';
        case 'software':
            return '#818cf8';
        case 'cicd':
            return d.schematicBattery;
        case 'security':
            return '#f87171';
        case 'people':
            return '#34d399';
        case 'governance':
            return '#c084fc';
        case 'project':
            return '#fb7185';
        case 'manufacturing':
            return '#f59e0b';
        case 'logistics':
            return '#2dd4bf';
        case 'quality':
            return '#4ade80';
        case 'industrial':
            return '#67e8f9';
        case 'cloud':
            return '#93c5fd';
        case 'ai':
            return '#e879f9';
        case 'status':
            return d.schematicLedStroke;
        case 'layout':
            return '#64748b';
        case 'facilities':
            return '#f97316';
        case 'transport':
            return '#0ea5e9';
        case 'nature':
            return '#22c55e';
        case 'devices':
            return '#8b5cf6';
        default:
            return d.edgeMuted;
    }
}
/** Standalone pipeline / process symbol tile (catalog + custom diagrams). */
export function createPipelineSymbol(app, type, x, y, label) {
    var kind = resolvePipelineSymbolKind(type);
    var meta = getPipelineSymbolMeta(kind);
    var accent = categoryAccent(meta.category);
    var wrap = app.group({ x: x, y: y });
    var radius = 4;
    var pad = app.group({ listening: false });
    pad.mask = app.roundedRect({
        width: SYMBOL_SIZE,
        height: SYMBOL_SIZE,
        cornerRadius: radius,
        listening: false,
    });
    addCardChrome(app, pad, {
        width: SYMBOL_SIZE,
        height: SYMBOL_SIZE,
        cornerRadius: radius,
        fill: getActiveDiagram().schematicFill,
        stroke: getActiveDiagram().labelPillStroke,
        strokeWidth: 1,
        shadow: null,
        sheen: false,
    });
    var topPad = ACCENT_H + 4;
    var sidePad = 6;
    var bottomPad = 6;
    var availW = SYMBOL_SIZE - sidePad * 2;
    var availH = SYMBOL_SIZE - topPad - bottomPad;
    var scale = Math.min(availW / SYMBOL_SIZE, availH / SYMBOL_SIZE) * 0.94;
    var glyphHost = app.group({
        x: (SYMBOL_SIZE - SYMBOL_SIZE * scale) / 2,
        y: topPad + (availH - SYMBOL_SIZE * scale) / 2,
        scaleX: scale,
        scaleY: scale,
        listening: false,
    });
    drawPipelineGlyph(app, glyphHost, kind);
    pad.add(glyphHost);
    wrap.add(pad);
    addAccentBar(app, wrap, SYMBOL_SIZE, accent, ACCENT_H);
    wrap.metadata = { symbolType: kind, pipelineSymbolKind: kind };
    var caption = label !== null && label !== void 0 ? label : meta.label;
    wrap.add(app.text({
        text: caption,
        x: centerLabelX(caption, SYMBOL_SIZE),
        y: SYMBOL_SIZE + 6,
        fontSize: getActiveDiagram().fontSize.sm,
        fontWeight: '600',
        fontFamily: getActiveDiagram().fontFamily,
        fill: getActiveDiagram().schematicLabel,
        listening: false,
    }));
    return wrap;
}
function centerLabelX(label, boxWidth) {
    var approx = label.length * getActiveDiagram().fontSize.sm * 0.55;
    return (boxWidth - approx) / 2;
}
/** Draw a compact glyph into a pipeline stage card (local origin). */
export function drawPipelineStageGlyph(app, parent, type, x, y, size) {
    if (size === void 0) { size = 22; }
    var kind = resolvePipelineSymbolKind(type);
    var scale = size / SYMBOL_SIZE;
    var host = app.group({ x: x, y: y, scaleX: scale, scaleY: scale, listening: false });
    drawPipelineGlyph(app, host, kind);
    parent.add(host);
}
export { categoryAccent as pipelineCategoryAccent };
